import { useGtm } from '@gtm-support/vue-gtm'

export function trackPageView(rootFolder) {
    const gtm = useGtm()
    gtm.trackEvent({
        event: 'pageview',
        dimension2: rootFolder
    })
}

export function trackEvent (category, action, label) {
    const gtm = useGtm()
    gtm.trackEvent({
        event: 'event',
        category,
        action,
        label
    })
}